import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import './styles/theme.css'

const app = createApp(App)

app.mount('#app')
